import { createAction } from '@'
import { SetFormValues } from '@form'
import { SetModalVisible } from '@modal'

export default createAction('OpenCreateRole', (onSuccess = () => {}) => {
    SetFormValues('RoleForm', { onSuccess })
    SetModalVisible('RoleForm', true)
})
